/**
 * List Schema of RelatorioGeracao
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {RelatorioGeracao} from '@/model/resource/RelatorioGeracao'

/* TODO: review generated schema */
export class ListRelatorioGeracaoSchema extends Schema {
  readonly name = 'ListRelatorioGeracao'

  readonly fieldSet: FieldSet<RelatorioGeracao> = {
    idRelatorioGeracaoPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    responsavel: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.responsavel?.$id,
      },
    }),
    tipoRelatorio: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.tipoRelatorio?.$id,
      },
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataCriacao),
      },
    }),
    urlDownload: (): FieldComponent => ({
      is: Component.Render,
    }),
    dataGeracaoRelatorio: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.datetime(schema.model.dataGeracaoRelatorio),
      },
    }),
  }
}
